
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./url.shortener.cjs.production.min.js')
} else {
  module.exports = require('./url.shortener.cjs.development.js')
}
